import {Link} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import {Button} from '@/components/ui/button'
import {LockGlyph} from '@/components/ui/icons'
import {HelpIcon} from '@/components/help-icon'
import {KairosMark} from '@/components/kairos-mark'
import {PlanMejoramientoDownloadMenu} from '@/components/plan-mejoramiento-download-menu'
import type {SgsstAssessment} from '@/hooks/sgsst/evaluacion/use-sgsst'

export function PlanEncabezado({
  businessId,
  assessment,
  assessmentHref,
  propuestaHref,
  editable,
  fase2,
  proposalCount,
  truncated,
}: {
  businessId: string
  assessment: SgsstAssessment | null | undefined
  assessmentHref: string
  propuestaHref: string
  editable: boolean
  fase2: boolean
  proposalCount: number
  /** Pasado el `page_size` máximo del backend la lista llega recortada, y se dice. */
  truncated: {shown: number; total: number} | null
}) {
  const {t} = useTranslation()
  return (
    <div className="flex flex-wrap items-start justify-between gap-3">
      <div>
        <div className="flex items-center gap-2 text-foreground">
          <KairosMark />
          <h1 className="font-heading text-xl">{t('plan.title')}</h1>
          {/* Único disparador de ayuda del plan: los criterios por fila se explican acá (U4). */}
          <HelpIcon label={t('common.help.iconLabelFor', {campo: t('plan.title')})} testId="plan-ayuda">
            {t('plan.ayudaTip')}
          </HelpIcon>
        </div>
        {assessment?.is_closed ? (
          <p className="mt-1.5 flex items-center gap-2 text-sm text-muted-foreground" data-testid="plan-closed-line">
            <LockGlyph size={14} />
            {t('plan.closedLine', {year: assessment.period_year})}
          </p>
        ) : null}
        {truncated && (
          <p className="mt-2 text-[11.5px] text-tone-amber-fg" data-testid="plan-truncated-note">
            {t('plan.truncatedNote', truncated)}
          </p>
        )}
      </div>
      <div className="flex flex-col items-end gap-2">
        <div className="flex items-center gap-2.5">
          {editable && fase2 && proposalCount > 0 && assessment && (
            <Button asChild size="sm" data-testid="proponer-plan-cta">
              <Link to={propuestaHref}>{t('plan.propuesta.cta', {year: assessment.period_year})}</Link>
            </Button>
          )}
          {assessment && <PlanMejoramientoDownloadMenu businessId={businessId} year={assessment.period_year} />}
        </div>
        <Link to={assessmentHref} className="text-sm font-medium text-primary hover:underline">
          {t('plan.viewAssessment')}
        </Link>
      </div>
    </div>
  )
}
